import { createAction } from '@reduxjs/toolkit';
export const resetAllState = createAction('resetAllState');